import styled from 'styled-components';

export const PanelMobile = styled.article`
  position: fixed;
  z-index: 1;
  bottom: 0;
  left: 0;
  
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 25px;
  
  background: ${({ theme }) => theme.white};
  border-radius: 6px 6px 0 0;
  box-shadow: 0px -8px 24px rgba(0, 0, 0, 0.08);
  
  @media (min-width: 768px) {
    display: none;
  }
`;

export const MobileButton = styled.div`
  button {
    padding: 10px 20px;
    
    line-height: 1;
  }
`;

export const MobileTotal = styled.div`
  h3 {
    margin: 0;
    margin-bottom: 5px;
    padding: 0;
    
    font-size: 16px;
    line-height: 1;
  }
  
  p {
    margin: 0;
    padding: 0;
    
    font-weight: 700;
    font-size: 24px;
    line-height: 1;
  }
`;

export const PanelContainer = styled.article`
  @media (min-width: 768px) {
    padding: 0 25px;
    padding-top: 15px;
    padding-bottom: 35px;
    
    border-radius: 6px;
    background-color: ${({ theme }) => theme.white};
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }
`;

export const PanelImageContainer = styled.div`
  height: 185px;
  margin-bottom: 20px;

  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;

    object-fit: cover;
  }
  
  @media (min-width: 768px) {
    height: 220px;
  }
`;

export const PanelPaymentInfo = styled.div``;

export const PanelPaymentDelimiter = styled.hr`
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0;

  border: none;
  border-bottom: 1px solid #ececec;
`;

export const PanelPaymentItem = styled.p`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 10px 0;
  
  font-size: 16px;
  line-height: 1;

  span {
    &.semibold {
      font-weight: 600;
    }
    
    &.bold {
      font-weight: 700;
    }
    
    &.blue {
      color: ${({ theme }) => theme.blue};
    }
    
    &.medium {
      font-size: 20px;
    }
    
    &.large {
      font-size: 24px;
    }
  }
`;

export const PanelPaymentHeading = styled.h3`
  margin: 0;
  margin-top: 40px;
  margin-bottom: 10px;
  padding: 0;
  
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

export const PanelPaymentButtonContainer = styled.div`
  margin-top: 30px;
  
  button {
    padding-left: 40px;
    padding-right: 40px;
  }
  
  @media (min-width: 768px) {
    padding: 0 5px;
    
    button {
      width: 100%;
    }
  }
`;

export const CheckboxDescription = styled.p`
  margin-top: 0;
  color: ${({ theme, hasError }) => hasError ? theme.red : theme.black};
`;

export const PanelPaymentCheckboxContainer = styled.div`
  margin-top: 25px;
  
  ${CheckboxDescription} {
    margin-top: 0;
  
    font-size: 14px;
    line-height: 16px;
    
    a {
      font-weight: 700;
      color: ${({ theme }) => theme.blue};
      
      transition: color 0.3s;
      
      &:hover {
        font-weight: 700;
        color: ${({ theme }) => theme.black};
      }
    }
  }
`;
